import { useServicesStore } from '../../services';

export const useSimulationId = () => {
	const { simulation } = useServicesStore();

	return simulation?.simulationId;
};
